import { render } from "./InvalidIndicator.vue?vue&type=template&id=45482a70&scoped=true"
import script from "./InvalidIndicator.vue?vue&type=script&lang=js"
export * from "./InvalidIndicator.vue?vue&type=script&lang=js"

import "./InvalidIndicator.vue?vue&type=style&index=0&id=45482a70&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45482a70"]])

export default __exports__